export const CaptorMessageChannels = {
    ReportsMetaData: "ReportsMetaData",
    Report: "Report",
    AnnualReport: "AnnualReport"
};
//# sourceMappingURL=index.js.map